/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentityProviderEntity } from './IdentityProviderEntity';
import {
    IdentityProviderEntityFromJSON,
    IdentityProviderEntityFromJSONTyped,
    IdentityProviderEntityToJSON,
    IdentityProviderEntityToJSONTyped,
} from './IdentityProviderEntity';

/**
 * 
 * @export
 * @interface AuthConfigEntity
 */
export interface AuthConfigEntity {
    /**
     * 認証プロバイダー
     * 外部認証で用いる認証プロバイダー情報のリスト
     * @type {Array<IdentityProviderEntity>}
     * @memberof AuthConfigEntity
     */
    identityProviders: Array<IdentityProviderEntity>;
    /**
     * メール・パスワード認証有効状態
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    emailPasswordEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    otpEmailEnabled: boolean;
    /**
     * ワンタイムパスワード（SMS）認証有効状態
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    otpPhoneEnabled: boolean;
    /**
     * ログインリンク（Email）認証有効状態
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    linkPhoneEnabled: boolean;
    /**
     * ログインリンク（SMS）認証有効状態
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    linkEmailEnabled: boolean;
    /**
     * 外部認証有効状態
     * @type {boolean}
     * @memberof AuthConfigEntity
     */
    thirdPartyEnabled: boolean;
}

/**
 * Check if a given object implements the AuthConfigEntity interface.
 */
export function instanceOfAuthConfigEntity(value: object): value is AuthConfigEntity {
    if (!('identityProviders' in value) || value['identityProviders'] === undefined) return false;
    if (!('emailPasswordEnabled' in value) || value['emailPasswordEnabled'] === undefined) return false;
    if (!('otpEmailEnabled' in value) || value['otpEmailEnabled'] === undefined) return false;
    if (!('otpPhoneEnabled' in value) || value['otpPhoneEnabled'] === undefined) return false;
    if (!('linkPhoneEnabled' in value) || value['linkPhoneEnabled'] === undefined) return false;
    if (!('linkEmailEnabled' in value) || value['linkEmailEnabled'] === undefined) return false;
    if (!('thirdPartyEnabled' in value) || value['thirdPartyEnabled'] === undefined) return false;
    return true;
}

export function AuthConfigEntityFromJSON(json: any): AuthConfigEntity {
    return AuthConfigEntityFromJSONTyped(json, false);
}

export function AuthConfigEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthConfigEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'identityProviders': ((json['identityProviders'] as Array<any>).map(IdentityProviderEntityFromJSON)),
        'emailPasswordEnabled': json['emailPasswordEnabled'],
        'otpEmailEnabled': json['otpEmailEnabled'],
        'otpPhoneEnabled': json['otpPhoneEnabled'],
        'linkPhoneEnabled': json['linkPhoneEnabled'],
        'linkEmailEnabled': json['linkEmailEnabled'],
        'thirdPartyEnabled': json['thirdPartyEnabled'],
    };
}

export function AuthConfigEntityToJSON(json: any): AuthConfigEntity {
    return AuthConfigEntityToJSONTyped(json, false);
}

export function AuthConfigEntityToJSONTyped(value?: AuthConfigEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identityProviders': ((value['identityProviders'] as Array<any>).map(IdentityProviderEntityToJSON)),
        'emailPasswordEnabled': value['emailPasswordEnabled'],
        'otpEmailEnabled': value['otpEmailEnabled'],
        'otpPhoneEnabled': value['otpPhoneEnabled'],
        'linkPhoneEnabled': value['linkPhoneEnabled'],
        'linkEmailEnabled': value['linkEmailEnabled'],
        'thirdPartyEnabled': value['thirdPartyEnabled'],
    };
}

